import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import DataGrid, { Selection, Scrolling, Paging, FilterRow, LoadPanel as GridLoadPanel, SearchPanel, DataGridRef } from 'devextreme-react/data-grid'
import { Button } from 'devextreme-react/button'
import { useTranslation } from 'react-i18next'
import { useIxMainFilterType } from './hooks/use-main-filter-type'
import { useHandleKbEventsCallback } from 'hooks'
import { useIxOnScreen } from 'hooks/use-on-screen'
import { AccountType } from 'helpers/account-type-enum'

const FilterButtons = ({accountType, forceMainFilterType, name, visibleMainFilterType, disableMainFilterType}: any) => {
    const { t } = useTranslation()
    const [ mainFilterType, onMainFilterType ] = useIxMainFilterType(accountType, forceMainFilterType, name)

    return (
        <div className='filter-btns'>
            {
                accountType === AccountType.LedgerAccount && (
                    <div>
                        <Button
                            text={t('global:label.accountType.all')}
                            type={mainFilterType === 0 ? 'success': 'normal'}
                            id='0'
                            {...(!disableMainFilterType && visibleMainFilterType) && {onClick: onMainFilterType}}
                            disabled={disableMainFilterType && mainFilterType !== 0}
                            {...!visibleMainFilterType ? {visible: mainFilterType === 0} : {}}
                            {...disableMainFilterType && (mainFilterType === 0) && {elementAttr: {class: 'disabled'}}}
                            {...!visibleMainFilterType && {elementAttr: {class: 'visible'}}}
                            activeStateEnabled={!((!visibleMainFilterType || disableMainFilterType) && mainFilterType === 0)}
                        />
                        <Button
                            text={t('global:label.accountType.booked')}
                            type={(mainFilterType & 1) > 0 ? 'success': 'normal'}
                            id='1'
                            {...(!disableMainFilterType && visibleMainFilterType) && {onClick: onMainFilterType}}
                            disabled={disableMainFilterType && !((mainFilterType & 1) > 0)}
                            {...!visibleMainFilterType ? {visible: (mainFilterType & 1) > 0} : {}}
                            {...disableMainFilterType && ((mainFilterType & 1) > 0) && {elementAttr: {class: 'disabled'}}}
                            {...!visibleMainFilterType && {elementAttr: {class: 'visible'}}}
                            activeStateEnabled={!((!visibleMainFilterType || disableMainFilterType) && ((mainFilterType & 1) > 0))}
                        />
                    </div>
                )
            }
            {
                accountType === AccountType.SupplierAccount && (
                    <div>
                        <Button
                            text={t('global:label.accountType.all')}
                            type={mainFilterType === 0 ? 'success': 'normal'}
                            id='0'
                            {...(!disableMainFilterType && visibleMainFilterType) && {onClick: onMainFilterType}}
                            disabled={disableMainFilterType && mainFilterType !== 0}
                            {...!visibleMainFilterType ? {visible: mainFilterType === 0} : {}}
                            {...disableMainFilterType && (mainFilterType === 0) && {elementAttr: {class: 'disabled'}}}
                            {...!visibleMainFilterType && {elementAttr: {class: 'visible'}}}
                            activeStateEnabled={!((!visibleMainFilterType || disableMainFilterType) && mainFilterType === 0)}
                        />
                        <Button
                            text={t('global:label.accountType.booked')}
                            type={(mainFilterType & 1) > 0 ? 'success': 'normal'}
                            id='1'
                            {...(!disableMainFilterType && visibleMainFilterType) && {onClick: onMainFilterType}}
                            disabled={disableMainFilterType && !((mainFilterType & 1) > 0)}
                            {...!visibleMainFilterType ? {visible: (mainFilterType & 1) > 0} : {}}
                            {...disableMainFilterType && ((mainFilterType & 1) > 0) && {elementAttr: {class: 'disabled'}}}
                            {...!visibleMainFilterType && {elementAttr: {class: 'visible'}}}
                            activeStateEnabled={!((!visibleMainFilterType || disableMainFilterType) && ((mainFilterType & 1) > 0))}
                        />
                        <Button
                            text={t('global:label.accountType.withOP')}
                            type={(mainFilterType & 2) > 0 ? 'success': 'normal'}
                            id='2'
                            {...(!disableMainFilterType && visibleMainFilterType) && {onClick: onMainFilterType}}
                            disabled={disableMainFilterType && !((mainFilterType & 2) > 0)}
                            {...!visibleMainFilterType ? {visible: (mainFilterType & 2) > 0} : {}}
                            // {...disableMainFilterType && ((mainFilterType & 2) > 0) && {stylingMode: 'outlined'}}
                            {...disableMainFilterType && ((mainFilterType & 2) > 0) && {elementAttr: {class: 'disabled'}}}
                            {...!visibleMainFilterType && {elementAttr: {class: 'visible'}}}
                            activeStateEnabled={!((!visibleMainFilterType || disableMainFilterType) && ((mainFilterType & 2) > 0))}
                        />
                        <Button
                            text={t('global:label.accountType.active')}
                            type={(mainFilterType & 4) > 0 ? 'success': 'normal'}
                            id='4'
                            {...(!disableMainFilterType && visibleMainFilterType) && {onClick: onMainFilterType}}
                            disabled={disableMainFilterType && !((mainFilterType & 4) > 0)}
                            {...!visibleMainFilterType ? {visible: (mainFilterType & 4) > 0} : {}}
                            {...disableMainFilterType && ((mainFilterType & 4) > 0) && {elementAttr: {class: 'disabled'}}}
                            {...!visibleMainFilterType && {elementAttr: {class: 'visible'}}}
                            activeStateEnabled={!((!visibleMainFilterType || disableMainFilterType) && ((mainFilterType & 4) > 0))}
                        />
                        <Button
                            text={t('global:label.accountType.favorites')}
                            type={(mainFilterType & 8) > 0 ? 'success': 'normal'}
                            id='8'
                            {...(!disableMainFilterType && visibleMainFilterType) && {onClick: onMainFilterType}}
                            disabled={disableMainFilterType && !((mainFilterType & 8) > 0)}
                            {...!visibleMainFilterType ? {visible: (mainFilterType & 8) > 0} : {}}
                            {...disableMainFilterType && ((mainFilterType & 8) > 0) && {elementAttr: {class: 'disabled'}}}
                            {...!visibleMainFilterType && {elementAttr: {class: 'visible'}}}
                            activeStateEnabled={!((!visibleMainFilterType || disableMainFilterType) && ((mainFilterType & 8) > 0))}
                        />
                        <Button
                            text={t('global:label.accountType.propertyManager')}
                            type={(mainFilterType & 16) > 0 ? 'success': 'normal'}
                            id='16'
                            {...(!disableMainFilterType && visibleMainFilterType) && {onClick: onMainFilterType}}
                            disabled={disableMainFilterType && !((mainFilterType & 16) > 0)}
                            {...!visibleMainFilterType ? {visible: (mainFilterType & 16) > 0} : {}}
                            {...disableMainFilterType && ((mainFilterType & 16) > 0) && {elementAttr: {class: 'disabled'}}}
                            {...!visibleMainFilterType && {elementAttr: {class: 'visible'}}}
                            activeStateEnabled={!((!visibleMainFilterType || disableMainFilterType) && ((mainFilterType & 16) > 0))}
                        />
                        <Button
                            text={t('global:label.accountType.new')}
                            type={(mainFilterType & 32) > 0 ? 'success': 'normal'}
                            id='32'
                            {...(!disableMainFilterType && visibleMainFilterType) && {onClick: onMainFilterType}}
                            disabled={disableMainFilterType && !((mainFilterType & 32) > 0)}
                            {...!visibleMainFilterType ? {visible: (mainFilterType & 32) > 0} : {}}
                            {...disableMainFilterType && ((mainFilterType & 32) > 0) && {elementAttr: {class: 'disabled'}}}
                            {...!visibleMainFilterType && {elementAttr: {class: 'visible'}}}
                            activeStateEnabled={!((!visibleMainFilterType || disableMainFilterType) && ((mainFilterType & 32) > 0))}
                        />
                        <Button
                            text={t('global:label.accountType.bestForSector')}
                            type={(mainFilterType & 64) > 0 ? 'success': 'normal'}
                            id='64'
                            {...(!disableMainFilterType && visibleMainFilterType) && {onClick: onMainFilterType}}
                            disabled={disableMainFilterType && !((mainFilterType & 64) > 0)}
                            {...!visibleMainFilterType ? {visible: (mainFilterType & 64) > 0} : {}}
                            {...disableMainFilterType && ((mainFilterType & 64) > 0) && {elementAttr: {class: 'disabled'}}}
                            {...!visibleMainFilterType && {elementAttr: {class: 'visible'}}}
                            activeStateEnabled={!((!visibleMainFilterType || disableMainFilterType) && ((mainFilterType & 64) > 0))}
                        />
                    </div>
                )
            }
        </div>
    )}

export const IxAccount = ({handleGridReady, rangeMode, setGridRef, multiselect, onSelectionChanged, handleRowDblClick, onRowClick, height, accountType, dropdownbox,
    disableMainFilterType, removeMainFilterType, visibleMainFilterType, forceMainFilterType, searchText, name, selectedRowKey, data, isLoadingAccount}: any) => {
    const grid = useRef<DataGridRef>(null)
    const ref = useRef(null)
    const onScreen = useIxOnScreen(ref)
    const [text, setText] = useState(searchText)
    const { t } = useTranslation()

    const handleKbEventsCallback = useHandleKbEventsCallback(grid.current, dropdownbox, data)

    useEffect(() => {
        setGridRef(grid)
    },[setGridRef])

    useEffect(() => {
        if(onScreen) {
            const currentGrid = grid.current
            const searchField: any = currentGrid?.instance().element().querySelector('.dx-item.dx-multiview-item.dx-item-selected .dx-icon.dx-icon-search + input')
            data.length && searchField?.focus()
            currentGrid?.instance().navigateToRow(selectedRowKey?.AccountId)
        }
    },[selectedRowKey, onScreen, data])

    const columns = useMemo<any>(() => ([
        { dataField: 'AccountId', dataType: 'number', visible: true },
        { dataField: 'AccountNr', dataType: 'string', visible: true },
        { dataField: 'AccountName', dataType: 'string', visible: true },
        { dataField: 'ParentNr', dataType: 'string', visible: true },
        { dataField: 'AdditionalInfo1', dataType: 'string', visible: true },
        { dataField: 'AdditionalInfo2', dataType: 'string', visible: true },
        { dataField: 'AdditionalInfo3', dataType: 'string', visible: true },
        { dataField: 'AdditionalInfo4', dataType: 'string', visible: true },
        { dataField: 'AdditionalInfo5', dataType: 'number', visible: true },
        { dataField: 'BuKrNr', dataType: 'number', visible: true },
    ]), [])

    const _customizeColumns = useCallback((columns: any[]) => {
        const customizeColumns: any = {
            [AccountType.PersonAccount]: () => {
                columns.forEach(col => {
                    if(col.dataField === 'AdditionalInfo1') { col.caption = 'BIC' }
                    if(col.dataField === 'AdditionalInfo2') { col.caption = 'IBAN' }
                    if(col.dataField === 'AdditionalInfo3') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo4') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo5') { col.visible = false }
                    if(col.dataField === 'BuKrNr') { col.visible = false }
                })
            },
            [AccountType.LedgerAccount]: () => {
                columns.forEach(col => {
                    if(col.dataField === 'AdditionalInfo1') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo2') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo3') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo4') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo5') { col.visible = false }
                    if(col.dataField === 'BuKrNr') { col.visible = false }
                })
            },
            [AccountType.SupplierAccount]: () => {
                columns.forEach(col => {
                    if(col.dataField === 'AdditionalInfo1') { col.caption = 'BIC' }
                    if(col.dataField === 'AdditionalInfo2') { col.caption = 'IBAN' }
                    if(col.dataField === 'AdditionalInfo3') { col.caption = t('global:label.accountType.city') }
                    if(col.dataField === 'AdditionalInfo4') { col.caption = t('global:label.accountType.customerNumber') }
                    if(col.dataField === 'AdditionalInfo5') { col.visible = false }
                    if(col.dataField === 'BuKrNr') { col.visible = false }
                })
            },
            [AccountType.ProjectAccount]: () => {
                columns.forEach(col => {
                    if(col.dataField === 'AdditionalInfo1') { col.caption = t('global:label.accountType.validFrom') }
                    if(col.dataField === 'AdditionalInfo2') { col.caption = t('global:label.accountType.validTo') }
                    if(col.dataField === 'AdditionalInfo3') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo4') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo5') { col.visible = false }
                    if(col.dataField === 'BuKrNr') { col.visible = false }
                })
            },
            [AccountType.CostCenterAccount]: () => {
                columns.forEach(col => {
                    if(col.dataField === 'AdditionalInfo1') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo2') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo3') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo4') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo5') { col.visible = false }
                    if(col.dataField === 'BuKrNr') { col.visible = false }
                })
            },
            [AccountType.AnlageAccount]: () => {
                columns.forEach(col => {
                    if(col.dataField === 'AdditionalInfo1') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo2') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo3') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo4') { col.visible = false }
                    if(col.dataField === 'AdditionalInfo5') { col.visible = false }
                    if(col.dataField === 'BuKrNr') { col.visible = false }
                })
            }
        }

        customizeColumns[accountType]()
        
    }, [accountType, t])

    useEffect(() => {
        setText(searchText)
    },[searchText])

    useEffect(() => {
        const currentGrid = grid.current
        if (isLoadingAccount) {
            currentGrid?.instance().beginCustomLoading('')
        } else {
            currentGrid?.instance().endCustomLoading()
            }

    },[isLoadingAccount, grid])

    const _handleGridReady = useCallback((e: any) => {
        handleGridReady(e, grid)
       
    }, [handleGridReady])

    return (
        <div style={{display: 'inline'}} ref={ref} {...!multiselect ? {onKeyDown: handleKbEventsCallback} : {}}>
            {
                (!removeMainFilterType && (accountType === AccountType.LedgerAccount || accountType === AccountType.SupplierAccount)) && 
                    <FilterButtons
                        accountType={accountType}
                        forceMainFilterType={forceMainFilterType}
                        removeMainFilterType={removeMainFilterType}
                        name={name}
                        visibleMainFilterType={visibleMainFilterType}
                        disableMainFilterType={disableMainFilterType}
                    />
            }

            <DataGrid
                ref={grid}
                id='dropdown-grid'
                dataSource={data}
                height={height || '100%'}
                columns={columns}
                customizeColumns={_customizeColumns}
                repaintChangesOnly={true}
                showBorders={true}
                showColumnLines={true}
                onRowDblClick={handleRowDblClick}
                // {...!multiselect ? {onRowClick: onRowClick} : {onSelectionChanged: onSelectionChanged}}
                {...!multiselect ? {onRowClick: onRowClick} : {}}
                onSelectionChanged={onSelectionChanged}
                onContentReady={_handleGridReady}
                keyExpr='AccountId'
                {...!rangeMode && onScreen ? {selectedRowKeys: [selectedRowKey?.AccountId]} : {}}
                >
                <Selection mode={multiselect ? 'multiple' : 'single'} deferred={false} showCheckBoxesMode={ multiselect ? 'always' : 'none'} />
                <Scrolling mode='virtual' />
                <Paging enabled={true} pageSize={10} />
                <FilterRow visible={true} />
                <GridLoadPanel enabled={isLoadingAccount} />
                <SearchPanel searchVisibleColumnsOnly={true} visible={true}  defaultText={text}/>
            </DataGrid>
        </div>
    )
}
